import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-kebab-horizontal",
  templateUrl: "./med-icon-kebab-horizontal.component.html",
})
export class MedIconKebabHorizontalComponent extends SvgMixinComponent {}
